import React from 'react';
import Skeleton from 'components/Loading/Skeleton';

interface Props {
  height?: string;
  showLegend?: boolean;
  showAxes?: boolean;
  chartType?: 'bar' | 'line' | 'area';
}

export default function SkeletonChart({
  height = '500px',
  showLegend = false,
  showAxes = true,
}: // chartType = 'bar',
Props) {
  return (
    <div
      className="rounded-lg border border-palette-border bg-palette-black-2 p-4"
      style={{ height }}
      role="status"
      aria-label="Loading chart"
    >
      <div className="flex h-full gap-4">
        {/* Y-axis simulation */}
        {showAxes && (
          <div className="flex w-12 flex-col justify-between py-2">
            {[...Array(6)].map((_, i) => (
              <Skeleton key={i} width="w-8" height="h-2" />
            ))}
          </div>
        )}

        {/* Chart area */}
        <div className="flex flex-1 flex-col gap-2">
          {showLegend && (
            <div className="mb-2 flex gap-4">
              <Skeleton width="w-20" height="h-3" />
              <Skeleton width="w-20" height="h-3" />
            </div>
          )}

          <div className="flex flex-1">
            {/* Single large shimmer rectangle for all chart types */}
            <Skeleton width="w-full" height="h-full" className="rounded" />
          </div>

          {/* X-axis simulation */}
          {showAxes && (
            <div className="flex justify-between pt-2">
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="w-12" height="h-2" />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
